import styled from 'styled-components';

export const Title = styled.h2<{ selected: boolean }>`
  font-weight: ${(props) => (props.selected ? 'bold' : 400)};
  line-height: normal;
  font-size: calc(8px + 0.8vw);
  color: ${({ theme }) => theme.palette.primary.main};
  position: relative;
  left: -50%;
  white-space: nowrap;
`;

export const TextWrapper = styled.div`
  position: relative;
  top: 40px;
  max-height: 0;
  display: flex;
  left: 15px;
  align-items: center;
  justify-content: center;
`;

export const CompletedLine = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  height: 0px;
  width: 100%;
  position: relative;
  z-index: -100;
`;

export const IncompletedLine = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.divider};
  height: 0px;
  width: 100%;
  position: relative;
  z-index: -100;
`;

export const ContainerHorizontalFull = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  z-index: 1;
`;

export const ContainerHorizontal = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  z-index: 100;
`;

export const HorizontalStepper = styled.div`
  width: 12vw;

  &:last-child {
    width: 0;
  }
`;
